const defaults = {
  units: 'px',

  breakpoints: [
    { name: 'xs', value: 0 },
    { name: 'sm', value: 600 },
    { name: 'md', value: 1024 },
    { name: 'lg', value: 1440 },
    { name: 'xl', value: 1800 },
  ],
}

// state will end up looking something like this {xs:false, sm:true, md: false...}
const state = {
  current: null,
  get smUp() { return this.sm || this.md || this.lg || this.xl },
  get mdUp() { return this.md || this.lg || this.xl },
  get lgUp() { return this.lg || this.xl },

  get lgDown() { return this.xs || this.sm || this.md || this.lg },
  get mdDown() { return this.xs || this.sm || this.md },
  get smDown() { return this.xs || this.sm },
};

export default function (Vue, options) {

  let settings = Object.assign({}, defaults, options);

  // Set up MediaQueryList listeners to update state
  settings.breakpoints
    .sort((a, b) => a.value - b.value)
    .forEach((bp, index) => {
      let next = settings.breakpoints[index + 1];
      let mq = `(min-width: ${bp.value}${settings.units})`;
      if(next) mq += ` and (max-width: ${next.value - 1}${settings.units})`;

      let mqList = window.matchMedia(mq);
      mqList.addListener(e => {
        state[bp.name] = e.matches
        if(state[bp.name]) state.current = bp.name
      });

      // Set initial state
      state[bp.name] = mqList.matches;
      if(state[bp.name]) state.current = bp.name
    });    

  // Mixin state into all components as "$breakpoints"
  Object.defineProperty(Vue.prototype, '$breakpoints', {
    get () { return this.$root._breakpoints }
  });

  Vue.mixin({
    beforeCreate () {
      Vue.util.defineReactive(this, '_breakpoints', state);
    },
  });

  // A helper component
  Vue.component('breakpoints', {
    functional: true,
    abstract: true,
    render: function (h, { children, props }) {
      if(props[state.current] === "" || props[state.current] === true) {
        return children.length === 1 ? children[0] : h('div', children)
      }
    },
    props: settings.breakpoints.map(bp => bp.name)
  })
}